import { api } from "../api";

export type CancelResult = { cancelled: true } | { cancelled: false; message: string };

/**
 * Cancels a booking on Pony. The booking may leave the screen only when this says so: on a failure
 * Pony still holds the bike for the rider.
 */
export async function cancelBooking(id: string): Promise<CancelResult> {
  try {
    await api.post(`/bookings/${encodeURIComponent(id)}/cancel`);
    return { cancelled: true };
  } catch {
    return {
      cancelled: false,
      message: "Annulation impossible pour le moment. Votre vélo reste réservé.",
    };
  }
}
